import { useTranslation } from "react-i18next";
import PageWrapper from "../../components/PageWrapper.tsx";
import ChallengesAll from "@/pages/challenges/ChallengesAll.tsx";
import ChallengesParticipate from "@/pages/challenges/ChallengesParticipate.tsx";
import { useState } from "react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";

export default function ChallengesPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"all" | "my">("all");

  return (
    <PageWrapper backPath="/">
      <div className="fixed inset-0 flex flex-col bg-dark pt-safe-top">
        {/* Tabs — fixed */}
        <div className="container pt-4 pb-2 shrink-0">
          <div
            className={`text-white bg-white/08 rounded-lg flex items-center justify-center relative p-1
              before:content-[''] before:absolute before:inset-y-1 before:bg-white/20
               before:flex before:items-center
              before:rounded-md before:transition-all before:duration-500 before:ease-in-out
              before:w-[calc(50%-5px)]
              ${
            activeTab === "all" ? "before:left-1" : "before:left-[calc(50%+1px)]"
          }`}
          >
            <VibratingButton
              onClick={() => setActiveTab("all")}
              className="relative text-sm font-medium duration-500 py-1 transition-all flex justify-center items-center text-white rounded-md z-10 text-center w-full"
            >
              {t("all_button")}
            </VibratingButton>
            <VibratingButton
              onClick={() => setActiveTab("my")}
              className="relative text-sm font-medium duration-500 py-1.5 leading-[18px] rounded-md transition-all z-10 w-full"
            >
              {t("participate_button")}
            </VibratingButton>
          </div>
        </div>

        {/* Content — scrollable */}
        <div className="flex-1 overflow-y-auto container pb-4">
          {activeTab === "all" && <ChallengesAll />}
          {activeTab === "my" && <ChallengesParticipate />}
        </div>
      </div>
    </PageWrapper>
  );
}
